import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EditResourceFetchedData, SubmitEditResourceData } from 'globals/store/share.data';
import { ShareWrapper } from './share-wrapper.component';
import { JoiResource } from 'globals/store/resources.data';
import { environment } from '../../../environments/environment';
import { CustomQuestion } from 'globals/store/events.data';
import { BrandingData, getJoiTemplate } from 'globals/store/publish.data';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { ShareResourceFormComponent } from './share-resource-form.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-edit-resource',
    template: `
<branding-wrapper
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div *ngIf="loading" class="loading">Loading...</div>
  <div *ngIf="!loading && !resource" [innerHTML]="helpers.strWithBreak(inactiveUrlMessage)" class="sorry"></div>
  <div *ngIf="submitted"  class="thanks">
    Thank you! Your profile information has been submitted.
  </div>
  @if(brandingData?.template){
    <share-edit-resource-form *ngIf="!!resource && !submitted"
      [topTitle]="(resource.name || 'Unnamed Resource') + ' Profile in ' + eventName"
      [eventId]="eventId"
      [resource]="resource"
      [publishCode]="publishCode"
      [customQuestions]="customQuestions"
      [error]="error"
      [processing]="processing"
      [template]="brandingData.template"
      (onSubmit)="submit()">
    </share-edit-resource-form>
  }
</branding-wrapper>  
`,
    styleUrls: ['./share.editPerformer.scss'],
    styles: [`
::ng-deep resource-contact-list resource-contact-card { max-width: unset !important; }
::ng-deep resource-contact-list .label { margin: 10px 0 20px; }

    `],
    standalone: true,
    imports: [BrandingWrapperComponent, CommonModule, ShareResourceFormComponent],
})
export class ShareResourceComponent extends ShareWrapper<ShareResourceComponent> {
    publishCode:string;
    loading:boolean;
    processing:boolean;
    submitted:boolean;
    resource: JoiResource
    eventId;
    eventName: string
    cannotSubmitMessage = "The resource profile can't be submitted at this time.\nPlease reload this page and try again."
    inactiveUrlMessage = "The resource profile is not currently available for editing.\n\nTo review or update your profile, please contact the event organiser and ask them to re-activate your edit profile webform."
    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    customQuestions: CustomQuestion[] = []
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=> {
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.publishCode = params.publishCode;
          const url = `${this.api}/load-resource-profile/${this.publishCode}`
          this.take1(this.http.get(url)).then((data: EditResourceFetchedData) => {
            console.log({ data })
            this.resource = data.resource
            this.eventId = data.eventId
            this.eventName = data.eventName
            document.title = "Resource Profile"
            this.loading = false
            this.customQuestions = data.customQuestions || []
            this.brandingData = data.brandingData
          }, (error) => {
            console.log(error)
            this.loading = false;
            document.title = "Resource Profile Share Unavailable";
          })
        } 
      })
    }
  
    async submit() {
      this.processing = true;
      const data: SubmitEditResourceData = {
        publishCode:this.publishCode,
        resource: this.resource,
        eventId: this.eventId,
      }
      const url = `${this.api}/submit-resource-profile`
      try {
        await this.take1(this.http.post(url, data))
        this.submitted = true;
      } catch (response) {
        console.log(response)
        this.showError(this.cannotSubmitMessage)
        return false
      }
      this.processing = false;
    }
}

